import { SwiperFlex, SwiperText, BouncingArrow, ArrowFlex, BouncingArrowLeft, SwiperSubText } from '../styled'
import { Flex, useMatchBreakpointsContext, Button, Text } from '@pancakeswap/uikit'
import Link from 'next/link'
import { NowText } from './styled'

const SlideSix = ({}) => {
  const { isDesktop, isMd } = useMatchBreakpointsContext()
  return (
    <>
      <Flex width="100%" height="100%">
        <Flex flex={isDesktop ? '1.5' : '0'} />
        <SwiperFlex>
          <Flex width="100%" flexDirection="column">
            <Text fontSize="48px" fontWeight="500" color="teal" textAlign="left">
              PLAY
            </Text>
            <Text mt="-1rem" mb="-1rem" fontSize="24px" fontWeight="500" textAlign="center" color="text">
              your
            </Text>
            <Text fontSize="48px" fontWeight="500" color="teal" textAlign="end">
              GAME
            </Text>
          </Flex>
          <Flex width="100%" flexDirection="column" justifyContent="flex-start" height={isDesktop ? '100%' : 'auto'}>
            <Text fontSize={isDesktop ? '24px' : '24px'} fontWeight="500" color="teal" textAlign="center">
              <span style={{ color: '#fff' }}>TRY THE </span>HOTTEST GAME<span style={{ color: '#fff' }}> ON </span>{' '}
              BASE
            </Text>
          </Flex>
          <Flex width="100%" justifyContent="center" flexDirection="column">
            <Flex width="100%" height="100%" flexDirection="column">
              <Text fontSize="36px" fontWeight="500" color="text" textAlign="center">
                PLAY DEEPSHOT
              </Text>
            </Flex>
            <Flex width="100%" justifyContent="center" alignItems="center" flexDirection="column">
              {/* <Link href="https://www.deepshot.xyz" passHref> */}
              <Button width="100%" variant="teal" as="a" href="https://www.deepshot.xyz" target="_blank">
                NOW LIVE!
              </Button>
              {/* </Link> */}
            </Flex>
          </Flex>
        </SwiperFlex>
        <Flex flex={isDesktop ? '1.5' : '0'} />
      </Flex>
    </>
  )
}

export default SlideSix
